import ContentCreatorDlg from "@/views/content/contentCreatorDlg/ContentCreatorDlg.vue";
import ContentPublishedToDlg from "@/views/content/contentPublishedToDlg/contentPublishedToDlg.vue";
import {ContentStatus} from "@/enums/ContentStatus";
export default {
    name: "ContentList",
    components: {
        ContentCreatorDlg,
        ContentPublishedToDlg
    },
    data() {
        return {
            search: "",
            loading: true,
            headers: [
                {
                    text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
                    sortable: false,
                    value: "name",
                },
                {
                    text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Type'],
                    sortable: false,
                    value: "type",
                },
                {
                    text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.DatePublished'],
                    sortable: false,
                    value: "datePublished",
                },
                {
                    text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Status'],
                    sortable: false,
                    value: "status",
                },
                {
                    text: this.$i18n.messages[this.$i18n.locale]['ContentCreator.PublishedTo'],
                    sortable: false,
                    value: "publishTo",
                    width: 120
                },
                {
                    text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Tags'],
                    sortable: false,
                    value: "tags",
                    width: 200
                },
                {
                    text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.CreatedBy'],
                    sortable: false,
                    value: "createdBy",
                },
            ],
            content: []
        }
    },
    computed: {
        facility() {
            return this.$store.state.authModule.currentFacilityData;
        },
        contentPages() {
            return this.$store.state.contentCreatorModule.content;
        },
        digitalSignages() {
            return this.$store.state.digitalSignageModule.currentDigitalSignageList
        },
        contentAllTags() {
            return this.$store.state.contentCreatorModule.contentTags;
        },
        contentList() {
            const search = this.search ? this.search.toLowerCase() : '';
            return search
              ? this.content.filter(content => {
                  const nameMatches = content.name.toLowerCase().includes(search);
                  const tagsMatch = Array.isArray(content.tags) && content.tags.some(tag => tag.name.toLowerCase().includes(search));
                  return nameMatches || tagsMatch;
              })
              : this.content;
        }
    },
    methods: {
        createContent() {
            this.$refs.ContentCreatorDlg.open(this.$t('ContentCreatorDlg.CreateContent'));
        },
        openContent(item) {
            window.location.href = `/content-list/${item.id.toString()}`;
        },
        isPublished(item) {
            return item.status === ContentStatus.Published;
        },
        publishTo(item) {
            return item.publishTo.map(x => x.digitalSignageName).join(", ");
        },
        openPublishedToDlg(item) {
            this.$refs.contentPublishedToDlg.open(item.publishTo, item.unPublishedTo, item);
        },
        tagsToString(tags) {
            return tags.map(x => x.name).join(', ');
        }
    },
    async created() {
        Promise.all([
            this.$store.dispatch("getCreatorContent"),
            this.$store.dispatch("getDigitalSignages"),
            this.$store.dispatch("getContentTags")
        ]).then(() => {
            const result = [];

            this.contentPages.forEach(content => {
                const obj: any = {
                    ...content,
                    publishTo: [],
                    unPublishedTo: [],
                    tags: []
                };

                this.digitalSignages.forEach(signage => {
                    if(signage?.pages && signage?.pages?.length) {
                        const page = signage?.pages.find(page => page.contentCreatorId === content.id);
                        if(page) {
                            obj.publishTo.push({
                                ...page,
                                digitalSignageName: signage.channelName,
                                digitalSignageId: signage.id
                            });
                        } else {
                            obj.unPublishedTo.push({
                                digitalSignageName: signage.channelName,
                                digitalSignageId: signage.id
                            });
                        }
                    } else {
                        obj.unPublishedTo.push({
                            digitalSignageName: signage.channelName,
                            digitalSignageId: signage.id
                        });
                    }
                });

                if(content?.tagsIds && content?.tagsIds?.length) {
                    content?.tagsIds.forEach(tagId => {
                        const tag = this.contentAllTags.find(x => x.id === tagId);
                        if(tag) {
                            obj.tags.push(tag);
                        }
                    })
                }

                result.push(obj);
            });

            this.content = result;

            this.loading = false;
        });
    },
}